export const actionTypes = {
  SET_STORAGE: 'SET_STORAGE'
} as const

export function setStorage(storage: string | undefined) {
  return { type: actionTypes.SET_STORAGE, storage }
}

export type Action = ReturnType<typeof setStorage>
